// Campaign attribution that survives the reader's path through the site.
//
// A campaign link may land on any public page (Visualising Wine, a story, a
// discover page), and the visitor may sign up from there, several pages
// later, or on another day. The token and topic from the first landing are
// kept here and read by the registration form.

export const TOPICS = {
  data: {
    label: "Market data and the Global Wine Observatory",
    line: "You came for the data. Your free account opens every country in the Atlas, Heatmap and Country Portraits.",
  },
  directory: {
    label: "The international directory",
    line: "You came to list your winery. Your free account gives it a profile in the international directory.",
  },
  research: {
    label: "Research co-creation",
    line: "You came to shape the research. Your free account lets you put questions to researchers and join projects.",
  },
};

const clean = (v) => String(v || "").toLowerCase().replace(/[^a-z0-9_-]/g, "").slice(0, 40);

export function rememberCampaignParams(search) {
  try {
    const params = new URLSearchParams(search);
    const ref = params.get("ref");
    const topic = clean(params.get("topic"));
    if (ref) {
      localStorage.setItem("campaign_ref", ref);
      sessionStorage.setItem("campaign_ref", ref);
    }
    if (topic) localStorage.setItem("campaign_topic", topic);
    return { ref, topic };
  } catch {
    return { ref: null, topic: null };
  }
}

export function storedTopic() {
  try {
    return clean(new URLSearchParams(window.location.search).get("topic")) || localStorage.getItem("campaign_topic") || "";
  } catch {
    return "";
  }
}

export function clearCampaignParams() {
  try {
    localStorage.removeItem("campaign_ref");
    sessionStorage.removeItem("campaign_ref");
    localStorage.removeItem("campaign_topic");
  } catch { /* storage blocked */ }
}
